import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import PropTypes from "prop-types";
import Axios from "axios";
import qs from "qs";
import WebFormView from "./WebFormView";

const axios = Axios.create();

const initialMarketingState = {
	F143: "",
	F144: "",
	F145: "",
	F146: "",
	F147: "",
	F148: "",
	F151: "",
};

function WebFormPublicView({ match }) {
	const intl = useIntl();

	const { path, params } = match;
	const { formId } = params;

	const isEmbed = path === "/form/:formId/embed";

	const [form, setForm] = useState();

	const [marketingDetails, setMarketingDetails] = useState(
		initialMarketingState,
	);

	useEffect(() => {
		const handleMessage = event => {
			if (event.data.type === "pc-parent-info") {
				const marDetails = { ...initialMarketingState };
				if (event.data.url) {
					const [url, queries] = event.data.url.split("?");
					marDetails.F143 = url;
					if (queries) {
						const queryObj = qs.parse(queries);
						if (queryObj.utm_campaign) marDetails.F144 = queryObj.utm_campaign;
						if (queryObj.utm_source) marDetails.F145 = queryObj.utm_source;
						if (queryObj.utm_medium) marDetails.F146 = queryObj.utm_medium;
						if (queryObj.utm_term) marDetails.F147 = queryObj.utm_term;
						if (queryObj.utm_content) marDetails.F148 = queryObj.utm_content;
					}
				}
				if (event.data.title) {
					marDetails.F151 = event.data.title;
				}
				setMarketingDetails(marDetails);
			}
		};
		const marDetails = { ...initialMarketingState };
		const [url, queries] = window.location.href.split("?");
		marDetails.F143 = url;
		if (queries) {
			const queryObj = qs.parse(queries);
			if (queryObj.utm_campaign) marDetails.F144 = queryObj.utm_campaign;
			if (queryObj.utm_source) marDetails.F145 = queryObj.utm_source;
			if (queryObj.utm_medium) marDetails.F146 = queryObj.utm_medium;
			if (queryObj.utm_term) marDetails.F147 = queryObj.utm_term;
			if (queryObj.utm_content) marDetails.F148 = queryObj.utm_content;
			if (queryObj.page_title) marDetails.F151 = queryObj.page_title;
		}

		if (isEmbed && document.referrer) marDetails.F143 = document.referrer;
		if (!isEmbed && document.title) marDetails.F151 = document.title;

		setMarketingDetails(marDetails);

		window.addEventListener("message", handleMessage);

		axios
			.get(`${process.env.BACKEND_URI}/api/v2/web-forms/${formId}/view`)
			.then(({ data }) => {
				const userInfo = { locale: data.data?.locale };
				setForm({ ...data.data, userInfo });
			})
			.catch(() => setForm(null));

		return () => {
			window.removeEventListener("resize", handleMessage);
		};
	}, []);

	if (form === undefined) return "";
	if (form === null) {
		if (isEmbed)
			return (
				<div className="pc-webform pc-webform-embed">
					<h4 className="pc-webform-title-404 pc-text-center slds-m-bottom_none">
						{intl.formatMessage({
							id: "automation.formNotFound",
						})}
					</h4>
				</div>
			);

		return (
			<div className="pc-webform pc-webform-theme-light">
				<div className="pc-webform-paper pc-webform-style-404">
					<h4 className="pc-webform-title-404 pc-text-center slds-m-bottom_none">
						{intl.formatMessage({
							id: "automation.formNotFound",
						})}
					</h4>
				</div>
			</div>
		);
	}

	if (isEmbed)
		return (
			<div className="pc-webform pc-webform-embed">
				<style>
					{`
						html, body, #app {
							background-color: transparent !important;
						}
						`}
				</style>
				<WebFormView form={form} marketingDetails={marketingDetails} />
			</div>
		);

	return (
		<div
			className={`pc-webform pc-webform-theme-${form.style.theme}`}
			style={{
				backgroundColor: form.style.backgroundColor,
			}}
		>
			<div
				className={`pc-webform-paper pc-webform-style-${form.style.fieldType}`}
			>
				<WebFormView form={form} marketingDetails={marketingDetails} />
			</div>
		</div>
	);
}

WebFormPublicView.propTypes = {
	match: PropTypes.object.isRequired,
};

export default WebFormPublicView;
